import { api } from './forshawGraphqlApi.generated.ts'
import { replenishmentPlanActions } from '@/data/replenishmentPlan/slice/replenishmentPlan.slice.ts'
import { RootState } from '../../../data/store.ts'

const enhancedGraphqlApi = api.enhanceEndpoints({
  addTagTypes: ['Plan'],
  endpoints: {
    GetPlan: {
      providesTags: ['Plan'],
      serializeQueryArgs: ({ queryArgs: { branchId } }) => {
        return { branchId }
      },
    },
    SearchProducts: {
      keepUnusedDataFor: 0,
    },
    RemoveBranchesSalableProduct: {
      async onQueryStarted({ productId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled

          dispatch(replenishmentPlanActions.removeProductFromPlan(productId))
        } catch (e) {
          console.error(e)
        }
      },
    },
    RemoveProductFromPlan: {
      async onQueryStarted({ productId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled

          dispatch(replenishmentPlanActions.removeProductFromPlan(productId))
        } catch (e) {
          console.error(e)
        }
      },
    },
    SpecifyProductPlan: {
      async onQueryStarted(
        { productId, month, amount },
        { dispatch, queryFulfilled, getState },
      ) {
        const state = getState() as RootState

        const previousAmount =
          state.replenishmentPlan.plannedItems[productId]?.[month]?.amount

        dispatch(
          replenishmentPlanActions.setProductPlannedItem({
            productId,
            month,
            amount,
          }),
        )

        try {
          await queryFulfilled
        } catch {
          if (previousAmount != null) {
            dispatch(
              replenishmentPlanActions.setProductPlannedItem({
                productId,
                month,
                amount: previousAmount,
              }),
            )
          }
        }
      },
    },
  },
})

export { enhancedGraphqlApi }
